<template lang="pug">
.modal.fade(
  :id="modalId",
  tabindex='-1',
  aria-labelledby='modalLabel',
  aria-hidden='true',
  v-on="{ 'hide.bs.modal': onHide, 'shown.bs.modal': onShow }"
)
  .modal-dialog
    .modal-content
      .modal-header
        h5#modalLabel.modal-title {{ title }}
        button.btn-close(
          v-if="!noCloseButton",
          type='button',
          data-bs-dismiss='modal',
          aria-label='Close'
        )
      .modal-body
        slot
      .modal-footer(v-if="!!$slots.footer")
        slot(name="footer")
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true
    },
    noCloseButton: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  emits: ['shown', 'hidden'],
  methods: {
    onHide(event) {
      this.$emit('hidden', event)
    },
    onShow(event) {
      this.$emit('shown', event)
    }
  }
}
</script>
